/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpStatusCode,
} from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { TranslocoService } from '@ngneat/transloco';
import { Observable, catchError, throwError } from 'rxjs';
import { SeverityEnum } from '../enums/severity.enum';
import { NotificationService } from '../services/notification.service';
import { isNullOrUndefined } from 'is-what';
import { AuthenticationService } from '../services/authentication.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  private translocoService = inject(TranslocoService);
  private notificationService = inject(NotificationService);
  private router = inject(Router);
  private authenticationService = inject(AuthenticationService);

  intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    return next.handle(req).pipe(
      catchError((er: HttpErrorResponse) => {
        if (
          er.status === HttpStatusCode.Forbidden ||
          er.status === HttpStatusCode.NotFound
        ) {
          this.redirectToHome();
        }
        if (er.status === HttpStatusCode.Gone) {
          this.authenticationService.removeToken();
          this.redirectToHome();
        } else {
          if (er.status !== HttpStatusCode.Unauthorized) {
            this.showNotificationMessage(er);
          }
        }

        return throwError(() => er);
      }),
    );
  }

  private redirectToHome(): void {
    this.router.navigate(['']);
  }

  private showNotificationMessage(er: HttpErrorResponse): void {
    if (
      !isNullOrUndefined(er.error) &&
      er.error.errors &&
      Object.keys(er.error.errors)?.length > 0
    ) {
      for (const error in er.error.errors) {
        const errorMessage = er.error.errors[error];

        this.notificationService.showToast(
          errorMessage,
          this.translocoService.translateObject('errors.title'),
          SeverityEnum.Error,
        );
      }
    } else {
      this.notificationService.showToast(
        er.error.errorMessage ? er.error.errorMessage : er.error.message,
        this.translocoService.translateObject('errors.title'),
        SeverityEnum.Error,
      );
    }
  }
}
